export enum ROLE {
	ADMIN = "admin",
	MANAGER = "manager",
}
